import { Options, Vue } from 'vue-class-component';
import Header from '@/components/Header.vue'
import { VueCookieNext } from 'vue-cookie-next'
@Options({
  components: {
    Header
  }
})
export default class App extends Vue {
  msg!: string
  path: string
  async mounted() {
      this.path = window.location.pathname
     if(!VueCookieNext.getCookie('CustID') && window.location.pathname!=='/login'){
        window.location.href = '/login'
      }
  }
}